@if(service.viewDroplistItems.length){
<div class='experience-overview-views-part'>
	@if(service.selectedViewItem(); as selectedViewItem){
	<droplist class="views-droplist" [items]='service.viewDroplistItems' [selectedItem]='selectedViewItem' (selectionChange)='service.onViewDroplistChange($event)' [filterable]='false' [navigation]='true' sortBy='customSort' style='display:inline-block'> </droplist>
	@switch (selectedViewItem.uniqueId) {
	@case (service.viewId.Overview) {
	<experience-overview-view-part></experience-overview-view-part>
	}
	}
	}
</div>
}